var _require = require('prettier/standalone'),
    join = _require.doc.builders.join;

var NumberLiteral = {
  print: function print(_ref) {
    var node = _ref.node;

    if (node.subdenomination) {
      return join(' ', [node.number, node.subdenomination]);
    }

    return node.number;
  }
};
module.exports = NumberLiteral;